import {Injectable} from '@angular/core';
import {Group} from '../../../shared/models/group';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SessionService} from '../session/session.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  loadedGroups: Group[] = [];

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) {
  }

  getAuthorizedGroups() {
    return this.loadedGroups;
  }

  observeAuthorizedGroups(): Observable<Group[]> {

    // call web service to get groups, use cookie to get groups ids

    const groupsId = this.sessionService.getPermittedGroupsId();

    const customerId = this.sessionService.getCustomerId();

    const url = `/webofficerpc/rest-endpoint/FeesOffice/groups?customerId=` + customerId + `&groupIds=` + groupsId.join('&groupIds=');

    console.log(url);

    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.http.get<Group[]>(url, {headers});
  }

  loadAuthorizedGroups() {

    // call web service to get groups, use cookie to get groups ids

    const groupsId = this.sessionService.getPermittedGroupsId();

    const customerId = this.sessionService.getCustomerId();

    const url = `/webofficerpc/rest-endpoint/FeesOffice/groups?customerId=` + customerId + `&groupIds=` + groupsId.join('&groupIds=');

    console.log(url);

    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    this.http.get<Group[]>(url, {headers}).subscribe(
      (groups: Group[]) => {
        this.loadedGroups = groups;
      }, (error) => {
        console.log(error);
      }
    );
  }

}
